
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Adventuresportsinnagpurdistric() {



  const cardData =
  {
    keyword: ' Adventure Sports Resort in Nagpur District',
    heading:  'Woodland Escape: Adventure Sports Resort in Nagpur District ',
    headingDescription: 'Woodland Escape Resort is an inviting adventure sports resort in Nagpur District, set within the lush green surroundings of the region and crafted for thrill-seekers and nature lovers alike. The resort features broad open lawns and forest-fringe trails suitable for outdoor activities like rope courses, nature-trek segments, team-building games, and more under the canopy of trees. Guests can immerse themselves in adventure during the day and retreat to cozy, nature-blended cottages in the evening for comfort and relaxation. With its blend of green surroundings, dedicated activity space, and warm hospitality, Woodland Escape Resort offers the perfect setting for both adrenaline-filled fun and restful stays in Nagpur’s countryside.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Adventure Sports Resort in Nagpur District",
      "description": "Experience thrilling adventure activities amidst the natural beauty of Nagpur District. This resort offers a perfect combination of outdoor fun, comfort, and scenic surroundings, ideal for adrenaline seekers and nature lovers alike."
    },
    {
      "name": "Nagpur Adventure Activity Resort",
      "description": "Nagpur Adventure Activity Resort offers a wide range of activities including trekking, zip-lining, rock climbing, and obstacle courses. Guests can enjoy guided adventure sessions while staying in comfortable eco-friendly accommodations."
    },
    {
      "name": "Nagpur Outdoor Sports Resort",
      "description": "This resort focuses on outdoor sports such as volleyball, football, cricket, archery, and cycling. Ideal for families, groups, and corporate outings, it combines active fun with scenic landscapes."
    },
    {
      "name": "Nagpur Jungle Adventure Resort",
      "description": "Nestled in the heart of Nagpur’s forests, this resort provides jungle treks, wildlife spotting, camping, and nature trails. Perfect for eco-adventure enthusiasts seeking an immersive wilderness experience."
    },
    {
      "name": "Nagpur Family Adventure Resort",
      "description": "Designed for families, this resort offers safe adventure activities for all age groups including obstacle courses, river trekking, nature walks, and team-building games, ensuring fun and engagement for everyone."
    },
    {
      "name": "Nagpur Extreme Sports Resort",
      "description": "For thrill-seekers, Nagpur Extreme Sports Resort provides high-adrenaline activities such as rappelling, rock climbing, bungee setups, and high rope challenges, supervised by professional trainers for safety."
    },
    {
      "name": "Nagpur River Sports Resort",
      "description": "Located near rivers, this resort offers water-based adventure sports like kayaking, rafting, and canoeing, along with riverside camping and bonfire experiences for an exciting outdoor getaway."
    },
    {
      "name": "Nagpur Hill Adventure Resort",
      "description": "Perched on hills, the resort combines trekking, mountain biking, zip-lining, and paragliding opportunities with panoramic views. Ideal for adventure enthusiasts and photography lovers alike."
    },
    {
      "name": "Nagpur Kids Adventure Resort",
      "description": "Specifically designed for children, this resort features safe adventure zones, nature trails, zip lines, obstacle courses, and fun educational activities to develop teamwork and outdoor skills."
    },
    {
      "name": "Nagpur Weekend Adventure Resort",
      "description": "Perfect for a short getaway, this resort offers weekend packages including guided treks, adventure sports, bonfires, outdoor games, and family-friendly activities amidst scenic surroundings."
    },
    {
      "name": "Nagpur Luxury Adventure Resort",
      "description": "Enjoy adventure without compromising on luxury. This resort provides premium accommodations, fine dining, spa facilities, and curated adventure experiences including guided treks, zip-lining, and river sports."
    },
    {
      "name": "Nagpur Booking Adventure Sports Resort",
      "description": "Easily book your adventure stay online with options for families, couples, and groups. Choose from day trips or extended stays with pre-planned adventure activity packages."
    },
    {
      "name": "Nagpur One Day Adventure Resort",
      "description": "Ideal for day outings, this resort offers a packed schedule of adventure activities, guided nature walks, team games, and recreational sports to make the most of a single day immersed in nature."
    },
    {
      "name": "Nagpur Eco Adventure Resort",
      "description": "Blending adventure with sustainability, this resort offers eco-conscious accommodations and activities like nature treks, wildlife spotting, and outdoor sports while promoting environmental awareness."
    },
    {
      "name": "Nagpur Team Outing Adventure Resort",
      "description": "Perfect for corporate groups and team-building events, this resort provides adventure-based challenges, obstacle courses, problem-solving games, and outdoor activities designed to strengthen teamwork and communication."
    }
  ],
  "tableData": [
    ["- Adventure Sports Resort in Nagpur District", "- Nagpur Adventure Activity Resort"],
    ["- Nagpur Outdoor Sports Resort", "- Nagpur Jungle Adventure Resort"],
    ["- Nagpur Family Adventure Resort", "- Nagpur Extreme Sports Resort"],
    ["- Nagpur River Sports Resort", "- Nagpur Hill Adventure Resort"],
    ["- Nagpur Kids Adventure Resort", "- Nagpur Weekend Adventure Resort"],
    ["- Nagpur Luxury Adventure Resort", "- Nagpur Booking Adventure Sports Resort"],
    ["- Nagpur One Day Adventure Resort", "- Nagpur Eco Adventure Resort"],
    ["- Nagpur Team Outing Adventure Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Adventure Sports Resort in Nagpur District",
    "WhyChoosedescription": "Woodland Escape Resort offers a thrilling adventure experience in Nagpur District, surrounded by lush greenery and forested landscapes. Perfect for families, groups, and adventure enthusiasts, it combines natural beauty with exciting outdoor activities."
  },
  {
    "WhyChooseheading": "Wide Range of Adventure Activities",
    "WhyChoosedescription": "Guests can enjoy activities such as rock climbing, zip-lining, obstacle courses, cycling, and guided nature treks. The resort ensures options for both beginners and seasoned adventurers, making every visit exciting and memorable."
  },
  {
    "WhyChooseheading": "Safe and Supervised Experiences",
    "WhyChoosedescription": "All adventure sports and outdoor activities are conducted under expert supervision with safety equipment provided. Families and groups can enjoy adrenaline-filled fun while ensuring maximum safety for everyone."
  },
  {
    "WhyChooseheading": "Comfortable Accommodation Amidst Nature",
    "WhyChoosedescription": "Woodland Escape Resort features cozy rooms and cottages designed for comfort after a day full of adventure. Guests can relax, enjoy forest views, and rejuvenate while staying close to activity zones."
  },
  {
    "WhyChooseheading": "Family-Friendly and Group-Oriented",
    "WhyChoosedescription": "The resort caters to families and groups with open spaces for games, team-building activities, and leisure pursuits. It’s ideal for creating memories together while engaging in exciting adventures."
  },
  {
    "WhyChooseheading": "Delicious Meals and Refreshments",
    "WhyChoosedescription": "After a day of outdoor excitement, guests can enjoy freshly prepared meals, snacks, and beverages. Woodland Escape ensures every visitor is energized and satisfied during their stay."
  },
  {
    "WhyChooseheading": "Accessible Yet Immersed in Nature",
    "WhyChoosedescription": "Located within Nagpur District, Woodland Escape Resort is easily accessible while offering a secluded and nature-rich environment. Guests can enjoy adventure sports without the hassle of long travel."
  }
]

































  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as an adventure resort in Nagpur district with adventure sports?",
    answer: "Woodland Escape Resort offers a nature‑rich stay in Nagpur district blended with outdoor fun and adventure sports — ideal for guests who want both relaxation and active experiences."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur city?",
    answer: "The resort is situated within comfortable driving distance from Nagpur city, making it easily accessible for a stay that includes adventure sports while still enjoying nature."
  },
  {
    question: "What adventure sports and outdoor activities does Woodland Escape Resort provide?",
    answer: "The resort features a range of outdoor activities such as cycling on nature trails, open‑lawn games, perhaps nature‑walks, rope‑oriented play and other adventure‑style offerings designed for fun and activity in a green setting."
  },
  {
    question: "Is Woodland Escape Resort suitable for families and groups seeking adventure sports stay?",
    answer: "Yes! The resort caters to families, friends and groups looking for active stays — with safe outdoor zones, fun activities and a natural environment that supports both thrill and comfort."
  },
  {
    question: "Does the resort provide meals and services to support a sports‑filled stay?",
    answer: "Absolutely. Woodland Escape Resort offers freshly prepared meals, snacks and beverages — ensuring you’re well‑fed and comfortable after enjoying the adventure activities."
  },
  {
    question: "How can we book Woodland Escape Resort for an adventure‑sports stay in Nagpur district?",
    answer: "You can book via phone or WhatsApp the resort’s reservations team, or through their official website. Booking in advance is advised, especially if you’d like to include specific adventure activity slots."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Patel, Nagpur",
    text: "Our stay at Woodland Escape Resort was full of fun and nature! We enjoyed the outdoor activities, the kids had great time exploring and playing. A perfect adventure resort stay in Nagpur district."
  },
  {
    name: "Ms. Anjali & Friends, Nagpur",
    text: "We picked Woodland Escape Resort for a weekend getaway with friends and loved it. The outdoor games and nature trails made it memorable. Highly recommended for adventure stay near Nagpur!"
  }
];
































      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const adventureSportsResortSchema = {
  "@context": "https://schema.org",
  "@type": "LodgingBusiness",
  "name": "Adventure Sports Resort in Nagpur District",
  "image": "https://woodlandescape.com/assets/images/nagpur-adventure-resort.jpg",
  "description": "Experience thrill and excitement at our Adventure Sports Resort in Nagpur District. Ideal for families, kids, and adventure seekers with outdoor activities, river sports, hill adventures, and team outings.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Nagpur",
    "addressRegion": "Maharashtra",
    "addressCountry": "IN"
  },
  "telephone": "+91-XXXXXXXXXX",
  "url": "https://woodlandescape.com/nagpur-adventure-sports-resort",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "37",
    "bestRating": "5",
    "worstRating": "1"
  },
  "amenityFeature": [
    {"@type": "LocationFeatureSpecification", "name": "Adventure Activities", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Family-Friendly", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Kids Activities", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Outdoor Sports", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "River & Hill Activities", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Team Outing Facility", "value": true}
  ]
};



  return (
    <div>
<Helmet>
  <title>Adventure Sports Resort in Nagpur District | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Discover the ultimate adventure at our Adventure Sports Resort in Nagpur District. Enjoy outdoor sports, jungle activities, hill adventures, river sports, and fun for families and kids." 
  />
  <meta 
    name="keywords" 
    content="Adventure Sports Resort in Nagpur District, Nagpur Adventure Activity Resort, Nagpur Outdoor Sports Resort, Nagpur Jungle Adventure Resort, Nagpur Family Adventure Resort, Nagpur Extreme Sports Resort, Nagpur River Sports Resort, Nagpur Hill Adventure Resort, Nagpur Kids Adventure Resort, Nagpur Weekend Adventure Resort, Nagpur Luxury Adventure Resort, Nagpur Booking Adventure Sports Resort, Nagpur One Day Adventure Resort, Nagpur Eco Adventure Resort, Nagpur Team Outing Adventure Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(adventureSportsResortSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/57.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Adventuresportsinnagpurdistric;